<router-outlet></router-outlet>
<app-toast></app-toast>
<app-confirm-dialog></app-confirm-dialog>

<!-- PWA Components -->
<app-pwa-install-prompt></app-pwa-install-prompt>
<app-pwa-update-prompt></app-pwa-update-prompt>
<app-offline-indicator></app-offline-indicator>
